class SjVariantGallery extends HTMLElement {
  connectedCallback() {
    this.data = JSON.parse(this.querySelector('.sj-gallery-data').textContent);
    this.fallback = JSON.parse(this.querySelector('.sj-gallery-fallback').textContent);
    this.seedPhotos = JSON.parse(this.querySelector('.sj-gallery-seeds')?.textContent || '[]');
    this.context = JSON.parse(this.querySelector('.sj-gallery-context')?.textContent || '{}');
    this.image = this.querySelector('.sj-gallery-main');
    this.thumbs = this.querySelector('.sj-gallery-thumbs');
    this.nativeFiles = new Map(JSON.parse(this.querySelector('.sj-gallery-native-files')?.textContent || '[]').map(file => [String(file.id), file.url]));
    this.refreshFileLinks(this.data);
    this.refreshFileLinks(this.seedPhotos);
    this.selectVariant(this.dataset.variantId);
    this.querySelector('.sj-gallery-prev').onclick = () => this.show(this.index - 1);
    this.querySelector('.sj-gallery-next').onclick = () => this.show(this.index + 1);
    this.variantListener = e => {
      if (e.detail?.data?.productId && String(e.detail.data.productId) !== this.dataset.productId) return;
      if (e.detail?.resource?.id) this.selectVariant(e.detail.resource.id);
    };
    document.addEventListener('variant:update', this.variantListener);
    this.image.addEventListener('touchstart', e => { this.touchX = e.changedTouches[0].clientX; }, {passive:true});
    this.image.addEventListener('touchend', e => { const distance=e.changedTouches[0].clientX-this.touchX; if(Math.abs(distance)>40) this.show(this.index+(distance<0?1:-1)); }, {passive:true});
  }
  refreshFileLinks(value) {
    if (!value || typeof value !== 'object') return;
    if (value.fileId && value.url) {
      const url = this.nativeFiles.get(String(value.fileId).split('/').pop());
      if (url) {
        const previous = value.url.split('?')[0];
        if (!value.thumbnail || value.thumbnail.split('?')[0] === previous) value.thumbnail = url;
        value.url = url;
        value.full = url;
      }
      return;
    }
    Object.values(value).forEach(child => this.refreshFileLinks(child));
  }
  disconnectedCallback() { document.removeEventListener('variant:update',this.variantListener); }
  selectVariant(id) {
    const mapped = this.data.variants?.[id];
    this.photos = mapped?.length ? mapped : this.data.default?.length ? this.data.default : [...(this.fallback.variants?.[id] || []), ...this.fallback.default];
    const nativePackshot = this.fallback.variants?.[id]?.[0] || this.fallback.default?.[0];
    if (nativePackshot) this.photos = [nativePackshot, ...this.photos.filter(photo => photo.role !== 'packshot')];
    const nativeContext = this.context.variants?.[id] || (Object.keys(this.context.variants || {}).length === 1 ? this.context.default : null);
    if (nativeContext) {
      const firstContext = this.photos.findIndex(photo => photo.role === 'contextual');
      if (firstContext >= 0) this.photos[firstContext] = {...this.photos[firstContext], url:nativeContext, thumbnail:nativeContext};
      else this.photos.splice(1,0,{url:nativeContext,role:'contextual',alt:this.image.alt});
    }
    this.photos = [...this.photos, ...this.seedPhotos].filter((photo,index,all) => all.findIndex(p => p.url === photo.url) === index);
    this.thumbs.replaceChildren();
    this.photos.forEach((photo,index) => {
      const button=document.createElement('button');button.type='button';button.setAttribute('aria-label',`View product image ${index+1}`);
      const img=document.createElement('img');img.src=photo.thumbnail||photo.url;img.alt=photo.alt||'';img.loading='lazy';button.append(img);
      button.onclick=()=>this.show(index);this.thumbs.append(button);
    });
    this.show(0);
  }
  show(index) {
    if (!this.photos.length) return;
    this.index=(index+this.photos.length)%this.photos.length;
    const photo=this.photos[this.index];this.image.src=photo.url;this.image.alt=photo.alt||'';
    this.querySelector('.sj-gallery-status').textContent=`${this.index+1} / ${this.photos.length}`;
    [...this.thumbs.children].forEach((button,i)=>button.setAttribute('aria-current',String(i===this.index)));
    this.querySelectorAll('.sj-gallery-stage button').forEach(button=>button.hidden=this.photos.length<2);
  }
}
if(!customElements.get('sj-variant-gallery'))customElements.define('sj-variant-gallery',SjVariantGallery);
